import { render, staticRenderFns } from "./dataV5.vue?vue&type=template&id=02070432&scoped=true&"
import script from "./dataV5.vue?vue&type=script&lang=js&"
export * from "./dataV5.vue?vue&type=script&lang=js&"
import style0 from "./dataV5.vue?vue&type=style&index=0&id=02070432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02070432",
  null
  
)

export default component.exports